import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MixpanelEvents, eventTracking } from "../utils/userTracking";

export function usePageViewTracking() {
  const location = useLocation();
  useEffect(() => {
    eventTracking(MixpanelEvents.page_view);
  }, [location.pathname]);
}
